// source: template-project@7007a338a apps/backoffice/src/components/ui/spinner/Spinner.tsx
// DEVIATION (plan K9, "Spinner has both aria-hidden and role=status"): TP sets aria-hidden when a label IS given,
// which hides the labelled status from assistive tech. Here the icon is hidden only when it has no label.
import { Loader2 } from 'lucide-react';

import { cn } from '@/lib/utils';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  label?: string;
}

const sizeClasses = {
  sm: 'size-4',
  md: 'size-6',
  lg: 'size-8',
} as const;

export function Spinner({ size = 'md', className, label }: SpinnerProps) {
  return (
    <Loader2
      className={cn(sizeClasses[size], 'motion-safe:animate-spin', className)}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? 'status' : undefined}
    />
  );
}
